import React from 'react';
import ReactDOM from 'react-dom';

import Router from './router';

import './index.css';

if (process.env.NODE_ENV !== 'production') {
    // 调试控制台仅在非生产环境按需加载，避免进入生产入口包。
    import('vconsole').then(({ default: VConsole }) => {
        new VConsole();
    });
}

ReactDOM.render(
    <Router />,
    document.getElementById('root')
);

// 如需采集应用性能指标，可传入回调记录结果，或上报到分析服务。
// reportWebVitals();
